import { useTenantContext } from "context/TenantContext";
 
 
export default function getAccountTimeZone () {
    const { db_settings } = useTenantContext();
    return db_settings?.metadata?.timeZone || 'Asia/Kolkata';
}
 
 
export function convertToAccountTimeZone(timezone: string, date: string | Date | null): Date | null {
    if (!date) return null;

    // Format the date to the timezone and parse it back to a Date object
    const localeString = new Date(date).toLocaleString('en-US', { timeZone: timezone });
    return new Date(localeString);
}

export function strToFormattedDate(ts: Date) {
    if (!ts) {
        return null; // Return null if no time string is provided
    }

    // Extract the hours, minutes, and period (AM/PM)
    const timeParts = ts.toString().split(' ');
    if (timeParts.length !== 2) {
        return null; // Return null if the time string is not valid
    }

    const [time, period] = timeParts;
    if (!period || (period !== 'AM' && period !== 'PM')) {
        return null; // Return null if the period is invalid
    }

    const [hours, minutes] = time.split(':');
    if (!hours || !minutes) {
        return null; // Return null if hours or minutes are missing
    }

    // Return the formatted time
    const formattedTime = `${hours}:${minutes}${period}`;
    return formattedTime;
}
